import { createContext, useContext } from 'react';
import type { RequestScrollCallback, WrapupFeedbackThankYouState, Env } from './types';


interface ConversationContextValue {
  submitQuestion?: (question: string, attachments?: File[]) => void;
  phase?: string;
  requestScroll?: RequestScrollCallback;
  /** After COMMENTS submit succeeds; drives thank-you title/body on ChatWrapupCard. */
  wrapupFeedbackThankYou?: WrapupFeedbackThankYouState;
  clearWrapupFeedbackThankYou?: () => void;
  isBotTurn?: boolean;
  env?: Env;
  sessionId?: string;
  conversationStarted?: boolean;
}

export const ConversationContext = createContext<ConversationContextValue>({});

export const useConversation = () => useContext(ConversationContext);
